export default __webpack_public_path__ + "static/media/membros-familia-icon.380d13f1.svg";